module.exports = __webpack_public_path__ + "static/media/portfolio2.51a009cb.png";